var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"device-status"},[_c('div',{staticClass:"dot",class:{
    'is-online': _vm.row.status === 'online',
    'is-offline': _vm.row.status === 'offline',
    'is-pending': _vm.row.status === 'pending' || _vm.row.status === null,
  }})])
}
var staticRenderFns = []

export { render, staticRenderFns }